const { getOffsetTop } = window.BAO.Utils

class HalfScreenMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    if (this.dataset.zoomDisabled === 'true') return

    super.connectedCallback()

    this.isTicking = false

    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setAttribute('active', '')
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll, {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.scaleMedia()
    if (this?.els?.content?.exists) {
      this.fadeContent()
    }
    this.toggleParallax()
  }

  toggleParallax () {
    if (!this.hasAttribute('data-parallax')) return

    const imageEndsParallaxing = getOffsetTop(this)

    this.classList.toggle(
      this.dataset.fixedClass,
      this.lastKnownY < imageEndsParallaxing,
    )
  }

  fadeContent () {
    const imageStartsParallaxing = getOffsetTop(this) + window.innerHeight / 4
    const imageEndsParallaxing = getOffsetTop(this) + window.innerHeight / 3
    const totalScrollAmount = imageEndsParallaxing - imageStartsParallaxing

    if (this.lastKnownY < imageStartsParallaxing) {
      this.els.content.element.style.cssText = `--opacity: 1`

      return
    }

    if (this.lastKnownY > imageEndsParallaxing) {
      this.els.content.element.style.cssText = `--opacity: 0`

      return
    }

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - imageStartsParallaxing) / totalScrollAmount
    const opacityAmount = 1 - scrollYAsAPercentageOfJourney

    this.els.content.element.style.cssText = `--opacity: ${opacityAmount}`
  }

  scaleMedia () {
    if (
      (window.BAO.MediaBreakpoints.isXsViewport &&
        this.dataset.mobileScale === 0) ||
      (window.BAO.MediaBreakpoints.isSm && this.dataset.desktopScale === 0)
    ) {
      return
    }

    const maxScale = window.BAO.MediaBreakpoints.isXsViewport
      ? this.dataset.mobileScale
      : this.dataset.desktopScale

    const imageStartsParallaxing = getOffsetTop(this) - window.innerHeight
    const imageEndsParallaxing = getOffsetTop(this)
    const totalScrollAmount = imageEndsParallaxing - imageStartsParallaxing

    if (this.lastKnownY < imageStartsParallaxing) {
      this.els.media.element.style.cssText = `--scale: ${maxScale}`

      return
    }

    if (this.lastKnownY > imageEndsParallaxing) {
      this.els.media.element.style.cssText = `--scale: 1`

      return
    }

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - imageStartsParallaxing) / totalScrollAmount
    const scaleAmount =
      maxScale - (maxScale - 1) * scrollYAsAPercentageOfJourney

    this.els.media.element.style.cssText = `--scale: ${scaleAmount}`
  }
}

if (!customElements.get('half-screen-media')) {
  customElements.define('half-screen-media', HalfScreenMedia)
}
